<div class="header-block navigation-bar" #systemHeader (mousedown)="startScrollOnDrag(systemHeader, $event)">
  <div class="home-button button-block"
       [ngClass]="{'task-socket': taskSocketEmit, 'chosen-route': currentUrl === '/home'}">
    <button mat-button (click)="routerButton('/home'); taskSocketEmit = false">
      <mat-icon>home</mat-icon>
    </button>
  </div>
  <div class="navigation-button button-block {{menuButton.class}}" *ngFor="let menuButton of menuButtons"
       [ngClass]="{'alerts-button-block': menuButton.title === 'Alerts', 'chosen-route': menuButton.url === currentUrl}">
    <button mat-button (click)="routerButton(menuButton.url)">
      {{menuButton.title}}
    </button>
  </div>
</div>
<div class="header-block right-bar">
  <div class="test-icon-block system-switch-button" (click)="switchOP.toggle($event)">{{systemState}}</div>

  <div class="test-icon-block" *ngIf="testProd" pTooltip="Test Database" tooltipPosition="bottom">TEST</div>

  <div class="link-icon-block" *ngIf="(linkStatus | async) === false" pTooltip="Real Time Updates Off"
       tooltipPosition="bottom">
    <mat-icon>link_off</mat-icon>
  </div>
  <div class="search-block" *ngIf="!currentUser.installationUser">
    <p-autoComplete #autoComplete (onSelect)="openProject($event)" [suggestions]="projects"
                    (onFocus)="projectsFromHistory()" [(ngModel)]="searchValue"
                    (completeMethod)="filterProjects($event)" field="name" [size]="30" placeholder="Search"
                    [minLength]="1"
                    [delay]="10"
    >
      <ng-template let-project pTemplate="item">
        <!--        <div></div>-->

        <div class="search-row">
          <i class="pi pi-clock" *ngIf="showTimeClock"></i>
          {{project.name}}
        </div>
      </ng-template>
    </p-autoComplete>
  </div>

  <div class="clock-in-block">
    <app-system-clock></app-system-clock>
  </div>


  <!-- <div class="notification-block alerts-block" *ngIf="projectAlerts > 0"> -->
    <div class="notification-block alerts-block">
    <button class="notification-button" mat-button disableRipple="true" (click)="alertsOP.toggle($event)"
            pTooltip="Alerts" tooltipPosition="bottom">
      <mat-icon>warning_amber</mat-icon>
      <span class="mention-badge" *ngIf="projectAlertsCount > 0">{{projectAlertsCount}}</span>
    </button>
  </div>

  <div class="notification-block mentions-block">
    <button class="notification-button" mat-button disableRipple="true" (click)="mnfOP.toggle($event)"
            pTooltip="Mentions" tooltipPosition="bottom">
      <mat-icon>alternate_email</mat-icon>
      <span class="mention-badge" *ngIf="mentionsCounter > 0">{{mentionsCounter}}</span>
    </button>
  </div>

  <div class="notification-block">
    <button class="notification-button" mat-button disableRipple="true" (click)="nfOP.toggle($event)"
            pTooltip="Notifications" tooltipPosition="bottom">
      <mat-icon>notifications</mat-icon>
      <span class="notification-badge" *ngIf="(unreadNotificationsCount | async) > 0">{{unreadNotificationsCount |
        async}}</span>
    </button>
  </div>

  <div class="profile-div" (click)="pbOP.toggle($event)">
    <!-- <div class="logout-button button-block">
      <button mat-button disableRipple="true">{{currentUser?.name}}</button>
    </div> -->

    <div class="avatar-block">
      <div class="word-avatar" style.background-color="#{{currentUser.bgColor}}">
        <div class="short-name">
          {{currentUser.shortCode}}
        </div>
      </div>
    </div>
  </div>
</div>

<p-overlayPanel #alertsOP styleClass="nfs-op-panel">
  <app-alerts-panel [alertsOP]="alertsOP"></app-alerts-panel>
</p-overlayPanel>

<p-overlayPanel #mnfOP styleClass="nfs-op-panel">
  <app-mention-panel [notificationOP]="mnfOP"></app-mention-panel>
</p-overlayPanel>

<p-overlayPanel #nfOP styleClass="nfs-op-panel">
  <app-notification-panel [notificationOP]="nfOP"></app-notification-panel>
</p-overlayPanel>

<p-overlayPanel #pbOP styleClass="profile-op-panel">
  <app-profile-panel [currentUser]="currentUser" [profileOP]="profileOP"></app-profile-panel>
</p-overlayPanel>

<p-overlayPanel #switchOP class="switch-op" [styleClass]="'switch-op-panel'">
  <div class="switch-op-block">
    <button mat-button *ngFor="let stateButton of systemStates" mat-button
            class="switch-btn"
            [disabled]="stateButton.title === systemState"
            [ngClass]="{'active-system': systemState === stateButton.title}" (click)="switchSystem(stateButton.title)">
      {{stateButton.title}}
    </button>
  </div>
</p-overlayPanel>


<!-- test -->
